import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex w-full flex-col items-center justify-center px-4 py-24 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-50 text-primary-500">
        <i className="ri-emotion-sad-line text-3xl" />
      </span>
      <h1 className="mt-6 text-3xl font-bold text-foreground-950 md:text-4xl">404 页面未找到</h1>
      <p className="mt-3 text-sm text-foreground-400 font-mono">{location.pathname}</p>
      <p className="mt-4 max-w-md text-sm text-foreground-500">
        你访问的页面不存在或已被移除，可以返回首页继续浏览影视内容。
      </p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          返回首页
        </Link>
        <Link
          to="/search"
          className="cursor-pointer whitespace-nowrap rounded-md border border-background-300 px-6 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          搜索影视
        </Link>
      </div>
    </div>
  );
}